import { getToday } from '@/common/functions/getToday';
import { useRef } from 'react';

const useSearchBox = ({ handleSearchCallback }) => {
	const today = getToday();

	const dateFromRef = useRef();
	const dateToRef = useRef();

	const handleSearch = () => {
		const dateFrom = new Date(dateFromRef.current.value).toISOString();
		const dateTo = new Date(dateToRef.current.value).toISOString();

		handleSearchCallback(dateFrom, dateTo);
	};

	return {
		today,
		dateFromRef,
		dateToRef,
		handleSearch,
	};
};

export default useSearchBox;
